import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../config";
import { ACCESS_TOKEN_NAME, GEO_LOCATION_KEY, GEO_POSITION_KEY, REFRESH_TOKEN_NAME } from "../shared/constants";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
const BACKEND_URL = config.apiBaseUrl;

export const baseApi = createApi({
  reducerPath: "baseApiReducer",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: async (headers) => {
      let accessToken = localStorage.getItem(ACCESS_TOKEN_NAME);
      if (!accessToken) return headers;
      const jwtToken = jwtDecode(accessToken)
      if (jwtToken?.exp && new Date(jwtToken.exp) >= new Date()) {
        const tokenRefreshResponse = await axios.post(`${BACKEND_URL}/auth/refresh-token`, {
          accessToken: localStorage.getItem(ACCESS_TOKEN_NAME),
          refreshToken: localStorage.getItem(REFRESH_TOKEN_NAME)
        });
        if (!tokenRefreshResponse?.data?.error) {
          accessToken = tokenRefreshResponse?.data?.data?.accessToken;
          if (accessToken) {
            localStorage.setItem(ACCESS_TOKEN_NAME, accessToken);
            headers.set("authorization", `Bearer ${accessToken}`);
          }
          const refreshToken = tokenRefreshResponse?.data?.data?.refreshToken;
          if (refreshToken) {
            localStorage.setItem(REFRESH_TOKEN_NAME, refreshToken);
          }
          return headers;
        }
      }

      if (accessToken && !headers.has("authorization")) {
        headers.set("authorization", `Bearer ${accessToken}`);
      }
      const geoPosition = localStorage.getItem(GEO_POSITION_KEY);
      if (geoPosition) {
        headers.set("Geo-Position", geoPosition);
      }
      const geoLocation = localStorage.getItem(GEO_LOCATION_KEY);
      if (geoLocation) {
        headers.set("Geo-Location", geoLocation);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});